export const PlacementActivityActions = {
  SetPlacementActivityInputFields: 'PlacementActivityActions.SetPlacementActivityInputFields',
  RetrievePlacementActivityList: 'PlacementActivityActions.RetrievePlacementActivityList',
  RetrievePlacementActivityCount: 'PlacementActivityActions.RetrievePlacementActivityCount',
  SetActivityPaginationParameters: 'PlacementActivityActions.SetActivityPaginationParameters',
  RetrieveActivityRecordCount: 'PlacementActivityActions.RetrieveActivityRecordCount'
};

export const PlacementActivityMutations = {
  SetPlacementActivityLoading: 'PlacementActivityMutations.SetPlacementActivityLoading',
  SetPlacementActivityInputFields: 'PlacementActivityMutations.SetPlacementActivityInputFields',
  SetPlacementActivityList: 'PlacementActivityMutations.SetPlacementActivityList',
  SetPlacementActivityCount: 'PlacementActivityMutations.SetPlacementActivityCount',
  SetActivityPaginationParameters: 'PlacementActivityMutations.SetActivityPaginationParameters',
  SetActivityRecordCount: 'PlacementActivityMutations.SetActivityRecordCount'
};

export const PlacementActivityGetters = {
  IsPlacementActivityLoading: 'PlacementActivityGetters.IsPlacementActivityLoading',
  PlacementActivityCount: 'PlacementActivityGetters.PlacementActivityCount',
  PlacementActivityInputFields: 'PlacementActivityGetters.PlacementActivityInputFields',
  PlacementActivityList: 'PlacementActivityGetters.PlacementActivityList',
  ActivityResultsPerPage: 'PlacementActivityGetters.ActivityResultsPerPage',
  ActivityResultsOffset: 'PlacementActivityGetters.ActivityResultsOffset',
  ActivityResultsRecordCount: 'PlacementActivityGetters.ActivityResultsRecordCount'
};
